import AsyncPage from 'pages/AsyncPage'

import universal from 'react-universal-component'
const component = universal(props => import('./CreateGroupPrivacyPage'))

export default new AsyncPage({
  pageComponent: component
})
